import service from "@irati/utils/tracking/index"
import {get} from "lodash"

const tracking = {}

tracking.started = (data) => {
  _wrapAndTrack("insights_user_survey_started", data)
}

tracking.finished = ({isReturningUser, ...data}) => {
  _wrapAndTrack("insights_user_survey_finished", data, {
    is_returning_user: isReturningUser
  })
}

tracking.expired = (data) => {
  _wrapAndTrack("insights_user_survey_expired", data)
}

tracking.answeredQuestion = ({questionObj, answer, ...data}) => {
  _wrapAndTrack("insights_user_survey_answered_question", data, {
    question_type: get(questionObj, "question.type"),
    question_text: get(questionObj, "question.text"),
    question_id: get(questionObj, "question.id"),
    question_driver_id: get(questionObj, "question.id"),
    question_number: get(questionObj, "questionNumber"),
    total_questions: get(questionObj, "totalQuestions"),
    answer_value: get(answer, "value"),
    answer_text: get(answer, "text")
  })
}

tracking.comment = ({comment, ...data}) => {
  _wrapAndTrack("insights_user_survey_comment", data, {
    sentiment: get(comment, "sentiment"),
    text_length: (get(comment, "text") || "").length,
    driver_id: get(comment, "driver.id"),
    driver_content_id: get(comment, "driver.contentId"),
    driver_name: get(comment, "driver.name")
  })
}

tracking.navigate = ({questionObj, modify, direct, ...data}) => {
  _wrapAndTrack("insights_user_survey_navigate", data, {
    question_type: get(questionObj, "question.type"),
    question_text: get(questionObj, "question.text"),
    question_id: get(questionObj, "question.id"),
    question_driver_id: get(questionObj, "question.id"),
    question_number: get(questionObj, "questionNumber"),
    total_questions: get(questionObj, "totalQuestions"),
    modify,
    direct
  })
}

export default tracking


/**
 *
 * @private
 */
function _wrapAndTrack(name, {userSurvey}, customData = {}) {
  const data = {
    user_survey_id: get(userSurvey, "id"),
    survey_id: get(userSurvey, "surveyId"),
    is_preview: !!get(userSurvey, "test"),
    team_ids: get(userSurvey, "teams"),
    ...customData
  }
  service.trackInsightsEvent(name, data)
}
